/**
 * @param {Object} clientManifest
 * @returns {Object}
 */
function filterForCdn (clientManifest) {
  const filesToMove = clientManifest?.async?.filter(url => url.match(/^mf\/cdn\/.*.js/g))

  filesToMove?.forEach(file => {
    clientManifest?.initial?.unshift(file)
  })

  return clientManifest
}

module.exports = { filterForCdn }
